import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { kind: String }

  connect() {
    this.mask()
    this.element.addEventListener("input", () => this.mask())
  }

  mask() {
    switch (this.kindValue) {
      case "number":
        this.element.value = this.cardNumber(this.element.value)
        break
      case "expiry":
        this.element.value = this.expiry(this.element.value)
        break
      case "cvv":
        this.element.value = this.digits(this.element.value, 4)
        break
      case "name":
        this.element.value = this.cardName(this.element.value)
        break
    }
  }

  cardNumber(value) {
    const digits = this.digits(value, 19)
    return digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim()
  }

  expiry(value) {
    const digits = this.digits(value, 4)
    if (digits.length <= 2) return digits
    return `${digits.slice(0, 2)}/${digits.slice(2)}`
  }

  cardName(value) {
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z ]/g, "")
      .replace(/\s+/g, " ")
      .toUpperCase()
  }

  digits(value, max) {
    return value.toString().replace(/\D/g, "").slice(0, max)
  }
}
